import React from 'react';
import styles from './home.module.css';
import bgImage from '../../assets/img/books.jpg';
export var Home = function () {
    return (React.createElement("div", { className: "contenair bg-cover w-full flex justify-center items-center " + styles.homeBackground, style: { backgroundImage: "url(" + bgImage + ")" } }));
};
export default Home;
